import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * Investor Tags Associations API
 */
class InvestorTagsAssociationsApi extends ApiBase {
  /**
   * create investortags/associations relations
   * @param {*} ids List of investorTagId/investorId
   */
  async create(payload) {
    const request = {
      url: `${this.API_URL}/investortags/associations`,
      headers: this.getHeaders(),
      method: 'POST',
      data: payload
    };

    const response = await axios.request(request);

    return response.data;
  }

  /**
   * delete investortags/associations relations
   * @param {*} ids List of investorTagId/investorId
   */
  async delete(payload) {
    const request = {
      url: `${this.API_URL}/investortags/associations`,
      headers: this.getHeaders(),
      method: 'DELETE',
      data: payload
    };

    const response = await axios.request(request);

    return response.data;
  }
}

export default new InvestorTagsAssociationsApi();
